<button mat-flat-button color="accent" (click)="fileInput.click()">
    <mat-icon>cloud_upload</mat-icon> Choose File
</button>
<input #fileInput hidden type="file" [formControl]="formControl" [formlyAttributes]="field">
